import React from "react";
import styled from "styled-components";
import palette from "../../lib/styles/palette";
import { Helmet } from 'react-helmet-async';
// import Button from "../common/Button";
import SideMenu from "../common/SideMenu";
// import { useState } from "react";


const ProjectViewer = ({ project, /*ownProject,*/ error, loading, actionButtons }) => {
    // const [modal, setModal] = useState(false);
    // const onConfirm = () => {
    //     setModal(!modal);
    // }
    // const onCancel = () => {
    //     setModal(!modal);
    // }

    // 에러 발생 시
    if (error) {
        if (error.message && error.response.status === 404) {
            return <ProjectViewerBlock>Not Existing Conveyor!!!</ProjectViewerBlock>
        }
        return <ProjectViewerBlock>Unknown Error!!!</ProjectViewerBlock>
    }
    
    // 로딩 중이거나 아직 프로젝트가 없을 때
    if (loading || !project) {
        return null;
    }
    
    const { title, body, user, publishedDate, tags } = project;
    const { comment, contractDate, contact } = body;
    
    return (
        <ProjectViewerBlock>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <SideMenu />
            <Content>
                <Caption>
                    <h1>Project Overview</h1>
                </Caption>
                <Body>
                    <ProjectHead>
                        <h3>{title}</h3>
                        <MainInfo>
                            <span>{comment}</span>
                            <span>계약일 : {contractDate}</span>
                            <span>{contact}</span>
                        </MainInfo>
                        <SubInfo>
                            <span>
                                <b>{user.username}</b>
                            </span>
                            <span>{new Date(publishedDate).toLocaleDateString()}</span>
                        </SubInfo>
                        <Tags>
                            {tags.map((tag, index) => (
                                <div key={index} className="tag">#{tag}</div>
                                ))}
                        </Tags>
                        {actionButtons}
                        {/* <div className="btn-area">
                            <StyledButton cyan to="/projects">프로젝트 리스트</StyledButton>
                            { ownProject && (
                                <div>
                                    <StyledButton cyan onClick={() => setModal(true)}>벨트 폭/속도</StyledButton>
                                    <AskBeltWidthModal visible={modal} onConfirm={onConfirm} onCancel={onCancel} />
                                    <StyledButton cyan to="/write/conveyors" >새 컨베이어 작성</StyledButton>
                                </div>
                            ) }
                        </div> */}
                    </ProjectHead>
                </Body>
            </Content>
        </ProjectViewerBlock>
    );
};


export default ProjectViewer;

const ProjectViewerBlock = styled.div`
    display: flex;
    // padding-top: 1rem;
`;

const Content = styled.div`
    width: 100%;
    margin: 1rem;
`;

const Caption = styled.div`
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;

    }
`;

const Body = styled.div`

`;

const ProjectHead = styled.div`
    border-bottom: 1px solid ${palette.gray[2]};
    padding-bottom: 1rem;
    margin-bottom: 3rem;
    h3 {
        font-size: 1.25rem;
        // 기본 높이가 높기때문에 위아래 마진을 줄이기 위해 
        line-height: 1.5;
        margin: 0;
    }
`;

const MainInfo = styled.div`
    span + span::before {
        content: '/';
        padding-left: 0.5rem;
        padding-right: 0.5rem;

    }
`;

const SubInfo = styled.div`
    margin-top: 1rem;
    color: ${palette.gray[6]};
    /* span 사이에 가운뎃 점 보여주기 */
    span + span::before {
        color: ${palette.gray[6]};
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        content: '\\B7';    /* 가운뎃점 문자 */
    }
`;

const Tags = styled.div`
    margin-top: 0.5rem;
    // display: flex;   // 굳이 flex를 쓰지 않고도 inlin-block으로 간단히 해결할 수 있다.
    .tag {
        display: inline-block;
        color: ${palette.cyan[7]};
        text-decoration: none;
        margin-right: 0.5rem;
        &:hover {
            color: ${palette.cyan[5]};
        }
    }
`;

// const StyledButton = styled(Button)`
//     // font-size: 0.9rem;
//     & + & {
//         margin-left: 1rem;
//     }
// `;